import { debounce } from 'lodash';
import { useState } from 'react';

/**
 * A modified React state hook to debounce setting the value
 * @param {any} initialState
 * @param {number} wait
 * @param {import('lodash').DebounceSettings} options
 * @returns {[any, import('react').Dispatch<any> & import('lodash').Cancelable]}
 */
export default function useDebouncedState(initialState, wait = 200, options = {}) {
  const [value, setValue] = useState(initialState);
  const debouncedSetValue = debounce(setValue, wait, options);
  return [value, debouncedSetValue];
}
